import React from "react";

export default function Landing() {
   
  return (
     <h1 style={{paddingLeft:'15px'}}>Hitchhiker ! Super Admin Landing Page</h1>
  );
}       
